export default __webpack_public_path__ + "static/media/karim-manjra-fm9wqDNXyQ0-unsplash.77fc77b6.jpg";